<template>
    <div class="statement-files-upload">
        <el-dialog class="invoice" :title="title" v-loading="isDialogLoading" :visible.sync="dialogVisible" width="28%"
            :close-on-click-modal="false">
            <el-upload class="upload-demo" drag action="" :show-file-list="false"  :before-upload="getUploadInfo" :http-request="submitUpload">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <!-- <div class="el-upload__tip" slot="tip"></div> -->
            </el-upload>
            <div class="template-download">
                <el-button type="text" @click="templateDownload">点击下载往来对账核对模板.xlsx</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getControlParam } from '../../../../api/common';

export default {
    props: {
        balanceDetail: {
            type: Object,
            default: () => {}
        },
        title: {
            type: String,
            default: '附件上传'
        }
    },
    data() {
        return {
            dialogVisible: false,
            isDialogLoading: false,
            controlParamSize: 1024
        };
    },
    methods: {
        // 上传文件之前钩子
        getUploadInfo(file) {
            const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            const extension = testmsg === 'xls' || testmsg === 'xlsx';
            if (!extension) {
                this.$message.warning('只能上传excel的文件');
                return false;
            }
            const isExceed = file.size / 1024 <= this.controlParamSize;
            if (!isExceed) {
                this.$message.warning('上传文件大小不能超过 ' + this.controlParamSize + 'KB');
                return false;
            }
        },
        // 自定义上传文件行为
        submitUpload(uploadData) {
            this.$emit('simpleUpload', uploadData);
        },
        // 模板下载
        templateDownload() {
            this.$emit('templateDownload');
        },
        getControlParamSize() {
            // 获取系统控制参数
            const formData = new FormData();
            formData.append('controlParam', 'BMS_UPLOAD_FILE_SIZE_CONTROL');
            getControlParam(formData).then(res => {
                if (res && res.code === '0') {
                    this.controlParamSize = res.data.value;
                } else {
                    this.controlParamSize = 1024; // 默认1024KB
                }
            });
        }
    },
    mounted() {
        this.getControlParamSize();
    }
};
</script>

<style lang="less">
.statement-files-upload {
    .el-dialog__header {
        border: none !important;
    }

    .template-download {
        display: flex;
        margin-top: 20px;
        font-size: 14px;
    }
}
</style>
